module.exports = __webpack_public_path__ + "media/images/country_flags/au-905c6843f0676ba1d1067aeb01a8329d.png";